/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Phone_InvalidInputs */

const vi_error_shop_phone_invalid = /** @type {(inputs: Error_Shop_Phone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số điện thoại chưa hợp lệ: 8–20 ký tự, chỉ gồm chữ số, dấu cách, dấu chấm (có thể bắt đầu bằng +).`)
};

/**

* @param {Error_Shop_Phone_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_phone_invalid = /** @type {((inputs?: Error_Shop_Phone_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Phone_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_phone_invalid(inputs)
});